function updatePrice() {
    const productData = document.querySelector(".product-single__meta");
    const mainProductCont = productData?.parentElement;
    const originalValue = document.querySelector(".shipmain .money")
    const additionalValue = mainProductCont.querySelector(".gpo-total-text span");
    const currentQty = document.querySelector(".product-form__input").value || 1;
    if (originalValue && additionalValue) {
        const ogValue = parseFloat(originalValue.textContent.replace("$", "").trim()) || 0;
        const adValue = parseFloat(additionalValue.textContent.replace("$", "").trim()) || 0;
        const totalValue = `$${((ogValue * currentQty) + adValue).toFixed(2)}`;
        const asgTotalPrice = document.querySelector(".custom-total-price .atc-total-price");
        if (!asgTotalPrice) return;
        asgTotalPrice.textContent = totalValue;
    } else if (originalValue && currentQty) {
        const ogValue = parseFloat(originalValue.textContent.replace("$", "").trim()) || 0;
        const totalValue = `$${(ogValue * currentQty).toFixed(2)}`;
        const asgTotalPrice = document.querySelector(".custom-total-price .atc-total-price");
        if (!asgTotalPrice) return;
        asgTotalPrice.textContent = totalValue;
    }
}

document.addEventListener("change", (e) => {
    if (!e.target.closest(".qtyField")) return;
    updatePrice();
})

document.addEventListener("click", (e) => {
    if (!e.target.closest(".qtyField")) return;
    updatePrice();
})

document.addEventListener("DOMContentLoaded", function () {
    const productData = document.querySelector(".product-single__meta");
    const mainProductCont = productData?.parentElement;

    const priceObserver = new MutationObserver(updatePrice);
    priceObserver.observe(mainProductCont.querySelector("form"), {
        subtree: true,
        attributes: true,
    })

    waitForElement(".gpo-container", (engravingAppCont) => {
        if (document.querySelector(".ASG-001-eng-top") || !window.engravings_settings.engraving_title) return;

        const engravingTop = document.createElement("div");
        engravingTop.classList.add("ASG-001-eng");
        engravingTop.innerHTML = `
          <div class="ASG-001-eng-top">
            <div class="ASG-001-eng-title">
              ${window.engravings_settings.engraving_title_icon}
              <h3>${window.engravings_settings.engraving_title}</h3>
            </div>
            ${window.innerWidth <= 768
                ? `<a class="ASG-001-eng-samples" href="${window.engravings_settings.engraving_cta_link}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V11.5C11.25 11.0858 11.5858 10.75 12 10.75Z" fill="black"/>
                            <path d="M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z" fill="black"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12ZM12 4.75C7.99594 4.75 4.75 7.99594 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25C16.0041 19.25 19.25 16.0041 19.25 12C19.25 7.99594 16.0041 4.75 12 4.75Z" fill="black"/>
                        </svg>
                    </a>`
                : `<a class="ASG-001-eng-samples" href="${window.engravings_settings.engraving_cta_link}">
                    ${window.engravings_settings.engraving_cta}
                   </a>`
            }
          </div>
          <p class="ASG-001-eng-desc">
            ${window.engravings_settings.engraving_description}
          </p>
        `;

        engravingAppCont.prepend(engravingTop);

        waitForElement(".ASG-001-eng-samples", (el) => {
            el.textContent = "See Font Samples";
        });

        const firstOption = engravingAppCont.querySelector("#select-1").querySelectorAll("option")[1];
        if (firstOption) {
            firstOption.textContent = firstOption.textContent.replace(window.engravings_settings.engraving_text_to_remove, "").trim();
        }
    });

    // Generic function to add appropriate heading based on label content
    function addAppropriateHeading(element) {
        const label = element.querySelector('.gpo-label .label-content');
        
        if (!label) return;
        
        const labelText = label.textContent.trim();
        
        // Check if it's Gift Wrapping
        if (labelText.includes('Gift Wrapping')) {
            if (!element.querySelector('.custom-giftwrap-heading')) {
                const giftHeading = document.createElement("div");
                giftHeading.classList.add("custom-giftwrap-heading");
                giftHeading.innerHTML = `<h3>Gift wrapping options</h3>`;
                element.prepend(giftHeading);
            }
        } 
        // Check if it's any Font selection (covers Engraving Font, Monogram Font, etc.)
        else if (labelText.includes('Font')) {
            if (!element.querySelector('.custom-font-heading')) {
                const fontHeading = document.createElement("div");
                fontHeading.classList.add("custom-font-heading");
                fontHeading.innerHTML = `<h3>Font Selection</h3>`;
                element.prepend(fontHeading);
            }
        }
    }

    // Handle all possible image-swatches elements (1-10 to be safe)
    for (let i = 1; i <= 10; i++) {
        waitForElement(`[data-element-id="image-swatches-${i}"]`, addAppropriateHeading);
    }
});

function waitForElement(selector, callback, timeout = 7000) {
    const intervalTime = 100;
    let elapsedTime = 0;

    const interval = setInterval(() => {
        const element = document.querySelector(selector);
        if (element) {
            clearInterval(interval);
            callback(element);
        } else if (elapsedTime >= timeout) {
            clearInterval(interval);
        }
        elapsedTime += intervalTime;
    }, intervalTime);
}

(function() {
  'use strict';

  // Track which elements already have an injected title (no cloning, no wrapping)
  const titledElements = new WeakSet();

  // ── Insert <h3> directly before the element — never clone ────────────────
  function injectTitle(element) {
    if (titledElements.has(element)) return;
    const labelEl = element.querySelector('.gpo-label .label-content');
    const name = labelEl ? labelEl.textContent.trim() : null;
    if (!name) return;
    const h3 = document.createElement('h3');
    h3.className = 'asg-injected-title';
    h3.textContent = name;
    element.parentNode.insertBefore(h3, element);
    // Hide the original GPO label so it doesn't duplicate our injected title
    const origLabel = element.querySelector('.gpo-label');
    if (origLabel) origLabel.style.display = 'none';
    titledElements.add(element);
  }

  function removeInjectedTitle(element) {
    if (!titledElements.has(element)) return;
    const prev = element.previousElementSibling;
    if (prev && prev.classList.contains('asg-injected-title')) prev.remove();
    // Restore the original GPO label
    const origLabel = element.querySelector('.gpo-label');
    if (origLabel) origLabel.style.display = '';
    titledElements.delete(element);
  }

  // ── Regroup visible gpo-col-4 elements into responsive CSS grids ──────────
  function regroupInputGrids(container) {
    // 1. Unwrap existing grid wrappers (move children back to container)
    container.querySelectorAll('.asg-input-grid').forEach(grid => {
      const frag = document.createDocumentFragment();
      grid.querySelectorAll('.asg-input-cell').forEach(cell => {
        while (cell.firstChild) frag.appendChild(cell.firstChild);
      });
      container.insertBefore(frag, grid);
      grid.remove();
    });

    // 2. Walk children and collect consecutive visible col-4 groups
    const groups = [];
    let currentGroup = null;

    Array.from(container.children).forEach(child => {
      const isCol4 = child.classList.contains('gpo-element') && child.classList.contains('gpo-col-4');
      const isH3   = child.classList.contains('asg-injected-title');
      const isDisabled = isCol4 && !!child.querySelector('input[disabled], select[disabled]');

      if (isCol4 && !isDisabled) {
        if (!currentGroup) currentGroup = [];
        const prev = child.previousElementSibling;
        const h3 = (prev && prev.classList.contains('asg-injected-title')) ? prev : null;
        currentGroup.push({ h3, el: child });
      } else if (!isH3) {
        // A non-h3, non-col4 element breaks the consecutive run
        if (currentGroup && currentGroup.length) { groups.push(currentGroup); currentGroup = null; }
      }
      // Lone h3 elements don't break the run — they'll be consumed by the next col4
    });
    if (currentGroup && currentGroup.length) groups.push(currentGroup);

    // 3. Wrap each group (split into rows of max 3)
    groups.forEach(group => {
      for (let start = 0; start < group.length; start += 3) {
        const row  = group.slice(start, start + 3);
        const cols = row.length; // 1, 2 or 3

        const grid = document.createElement('div');
        grid.className = 'asg-input-grid asg-grid-cols-' + cols;

        // Anchor: insert grid before the first node in this row
        const anchor = row[0].h3 || row[0].el;
        container.insertBefore(grid, anchor);

        row.forEach(({ h3, el }) => {
          const cell = document.createElement('div');
          cell.className = 'asg-input-cell';
          if (h3) cell.appendChild(h3);
          cell.appendChild(el);
          grid.appendChild(cell);
        });
      }
    });
  }

  function regroupAllInputGrids(gpoApp) {
    const containers = new Set();
    gpoApp.querySelectorAll('.gpo-element.gpo-col-4').forEach(el => {
      if (el.parentElement) containers.add(el.parentElement);
    });
    containers.forEach(regroupInputGrids);
  }

  // ── Sync titles for all dependent elements based on disabled state ────────
  function syncDependentTitles() {
    document.querySelectorAll('.gpo-element[data-has-clo]').forEach((el) => {
      const isDisabled = !!el.querySelector('select[disabled], input[disabled]');
      // Skip elements already handled by styleDropdown/transformSelect — they
      // inject the title inside their own .asg-section, no extra h3 needed.
      const alreadyStyled = !!el.querySelector('.asg-section');
      if (isDisabled) {
        removeInjectedTitle(el);
      } else if (!alreadyStyled) {
        injectTitle(el);
      }
    });
  }

  function cleanSelectorLabel(label) {
    const removeText = window.engravings_settings?.engraving_text_to_remove;
    if (removeText) {
      label = label.replace(removeText, '').trim();
    }
    return label;
  }

  function buildSelectorText(label) {
    const text = document.createElement('span');
    text.className = 'asg-selector-text';

    const priceMatch = label.match(/^(.+?)\s*(\(\+[^)]+\))\s*$/);
    if (priceMatch) {
      const labelSpan = document.createElement('span');
      labelSpan.className = 'asg-selector-label';
      labelSpan.textContent = priceMatch[1].trim();

      const priceSpan = document.createElement('span');
      priceSpan.className = 'asg-selector-price';
      priceSpan.textContent = ' ' + priceMatch[2].trim();

      text.appendChild(labelSpan);
      text.appendChild(priceSpan);
      return text;
    }

    text.textContent = label;
    return text;
  }

  // ── Top-level select → visual button group ───────────────────────────────
  function transformSelect(selectEl) {
    if (selectEl.dataset.asgDone) return;
    selectEl.dataset.asgDone = '1';

    const wrapper = selectEl.closest('.gpo-select');
    if (!wrapper) return;

    const gpoElement = selectEl.closest('.gpo-element');
    const labelEl = gpoElement ? gpoElement.querySelector('.gpo-label .label-content') : null;
    const displayName = labelEl ? labelEl.textContent.trim() : 'Option';

    const section = document.createElement('div');
    section.className = 'asg-section';

    const title = document.createElement('h3');
    title.className = 'asg-section-title';
    title.textContent = displayName;
    section.appendChild(title);

    const visualContainer = document.createElement('div');
    visualContainer.className = 'asg-visual-selector';

    let buttonCount = 0;
    selectEl.querySelectorAll('option').forEach((opt) => {
      if (!opt.value || opt.disabled) return;
      const val = opt.value;
      const label = cleanSelectorLabel(opt.textContent.trim());

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'asg-selector-btn' + (selectEl.value === val ? ' active' : '');
      btn.title = label;

      const circle = document.createElement('span');
      circle.className = 'asg-selector-circle';

      btn.appendChild(circle);
      btn.appendChild(buildSelectorText(label));

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        selectEl.value = val;
        visualContainer.querySelectorAll('.asg-selector-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        selectEl.dispatchEvent(new Event('input', { bubbles: true }));
      });

      visualContainer.appendChild(btn);
      buttonCount++;
    });

    if (buttonCount > 0) {
      section.appendChild(visualContainer);
      wrapper.style.display = 'none';
      wrapper.parentNode.insertBefore(section, wrapper.nextSibling);
      // Hide the original GPO label to avoid it duplicating our injected title
      if (gpoElement) {
        const origLabel = gpoElement.querySelector('.gpo-label');
        if (origLabel) origLabel.style.display = 'none';
      }
    }
  }

  // ── Dependent select → custom dropdown (no cloning, original stays in DOM) ─
  function styleDropdown(selectEl) {
    if (selectEl.dataset.asgDone) return;
    selectEl.dataset.asgDone = '1';

    const wrapper = selectEl.closest('.gpo-select');
    if (!wrapper) return;

    const gpoElement = selectEl.closest('.gpo-element');
    const labelEl = gpoElement ? gpoElement.querySelector('.gpo-label .label-content') : null;
    const displayName = labelEl ? labelEl.textContent.trim() : 'Option';

    const section = document.createElement('div');
    section.className = 'asg-section';

    const titleEl = document.createElement('h3');
    titleEl.className = 'asg-section-title';
    titleEl.textContent = displayName;
    section.appendChild(titleEl);

    const container = document.createElement('div');
    container.className = 'asg-dropdown-wrapper';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'asg-dropdown-button';

    const circle = document.createElement('span');

    const btnText = document.createElement('span');
    btnText.className = 'asg-dropdown-button-text';
    const currentOpt = selectEl.options[selectEl.selectedIndex];
    btnText.textContent = (currentOpt && currentOpt.value) ? currentOpt.textContent.trim() : '-Please Select-';

    const icon = document.createElement('span');
    icon.className = 'asg-dropdown-icon';
    icon.innerHTML = '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="#111111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    btn.appendChild(circle);
    btn.appendChild(btnText);
    btn.appendChild(icon);

    const listContainer = document.createElement('div');
    listContainer.className = 'asg-dropdown-list-container';

    const list = document.createElement('div');
    list.className = 'asg-dropdown-list';

    // Rebuild list fresh each time it opens (GPO may update options dynamically)
    function buildList() {
      list.innerHTML = '';
      selectEl.querySelectorAll('option').forEach((opt) => {
        if (!opt.value || opt.disabled) return;
        const val = opt.value;
        const label = opt.textContent.trim();

        const item = document.createElement('div');
        item.className = 'asg-dropdown-item' + (selectEl.value === val ? ' active' : '');



        const itemText = document.createElement('span');
        itemText.className = 'asg-dropdown-item-text';
        itemText.textContent = label;


        item.appendChild(itemText);

        item.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          selectEl.value = val;
          btnText.textContent = label;
          listContainer.classList.remove('open');
          list.querySelectorAll('.asg-dropdown-item').forEach(i => i.classList.remove('active'));
          item.classList.add('active');
          selectEl.dispatchEvent(new Event('change', { bubbles: true }));
          selectEl.dispatchEvent(new Event('input', { bubbles: true }));
        });

        list.appendChild(item);
      });
    }

    // ── FIX: Close all other dropdowns when this one opens ──────────────────
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Close all other open dropdowns
      document.querySelectorAll('.asg-dropdown-list-container.open').forEach((otherContainer) => {
        if (otherContainer !== listContainer) {
          otherContainer.classList.remove('open');
        }
      });
      
      buildList(); // always fresh
      listContainer.classList.toggle('open');
    });

    document.addEventListener('click', (e) => {
      if (!container.contains(e.target)) listContainer.classList.remove('open');
    });

    listContainer.appendChild(list);
    container.appendChild(btn);
    container.appendChild(listContainer);
    section.appendChild(container);

    wrapper.style.display = 'none';
    wrapper.parentNode.insertBefore(section, wrapper.nextSibling);
    // Hide the original GPO label to avoid it duplicating our injected title
    if (gpoElement) {
      const origLabel = gpoElement.querySelector('.gpo-label');
      if (origLabel) origLabel.style.display = 'none';
    }
  }

  // ── Process one gpo-app instance ─────────────────────────────────────────
  function processGpoApp(gpoApp) {
    // Top-level selects (not disabled, no data-has-clo) → visual buttons
    gpoApp.querySelectorAll('select[data-type="select"]').forEach((sel) => {
      if (sel.dataset.asgDone) return;
      if (sel.hasAttribute('disabled')) return; // dependent, skip for now
      const element = sel.closest('.gpo-element');
      if (!element) return;
      if (element.hasAttribute('data-has-clo')) return; // dependent, skip for now
      const validOpts = Array.from(sel.querySelectorAll('option')).filter(o => o.value && !o.disabled);
      if (validOpts.length >= 2) transformSelect(sel);
    });

    // Sync dependent titles immediately (all start disabled, so none shown)
    syncDependentTitles();
    regroupAllInputGrids(gpoApp);

    // Watch for GPO enabling/disabling dependent elements via CLO
    const observer = new MutationObserver(() => {
      // Style any dependent selects that GPO just enabled
      gpoApp.querySelectorAll('select[data-type="select"]:not([disabled])').forEach((sel) => {
        if (sel.dataset.asgDone) return;
        const element = sel.closest('.gpo-element');
        if (!element || !element.hasAttribute('data-has-clo')) return;
        const validOpts = Array.from(sel.querySelectorAll('option')).filter(o => o.value && !o.disabled);
        if (validOpts.length >= 2) styleDropdown(sel);
      });

      syncDependentTitles();
      regroupAllInputGrids(gpoApp);
    });

    observer.observe(gpoApp, {
      attributes: true,
      attributeFilter: ['disabled'],
      subtree: true,
    });
  }

  // ── Wait for GPO to render then init all instances ────────────────────────
  function init() {
    const gpoApps = document.querySelectorAll('.gpo-app');
    if (!gpoApps.length) { setTimeout(init, 300); return; }
    gpoApps.forEach(processGpoApp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// engraving option js

document.addEventListener("DOMContentLoaded", function () {
  const fontMap = {
    "Script": "Great Vibes",
    // "Block": "Cormorant Garamond",
    "Block": "GoogleSansFlexLight",
    // "Double line Block": "Kumar One Outline",
    "Double line Block": "ImperialScript",
    "Double line Script": "Monsieur La Doulaise",
    "Typo Upright": "Pinyon Script"
  };

  document.addEventListener("change", function (event) {
    const imageOption = event.target;

    if (
      !imageOption.matches(
        '.gpo-swatches.image-swatches.gpo-ov-item input[name="Engraving Font"]'
      )
    ) return;

    const fontName = fontMap[imageOption.value];
    if (!fontName) return;

    const fontPicker = document.querySelector(
      ".gpo-font-picker.gpo-ov-wrapper.horizontal"
    );

    if (!fontPicker) return;

    const fontOption = Array.from(
      fontPicker.querySelectorAll('input[name="Fonts Picker"]')
    ).find(function (input) {
      return input.value === fontName;
    });

    if (fontOption && !fontOption.checked) {
      fontOption.click();
    }
  });
});
